/**
 * Gmail's Snooze and "Label as" choices as menu entries (rows' "…" menu and the conversation's toolbar): the core
 * presets (logic/mail snoozePresets) in my time zone, then "Unsnooze" when it's snoozed; each label as a toggle.
 */
import type { MailLabel } from "@bundle/contracts";
import { snoozePresets } from "@bundle/core/logic/mail";
import type { MenuEntry, Translate } from "@bundle/ui";

export const myTimeZone = (): string => Intl.DateTimeFormat().resolvedOptions().timeZone;

export function snoozeEntries(t: Translate, when: (ts: number) => string, now: number, snoozedUntil: number | undefined, onSnooze: (until: number | null) => void): MenuEntry[] {
  const out: MenuEntry[] = snoozePresets(now, myTimeZone()).map((p) => ({
    id: `snooze-${p.id}`,
    label: t("mail.snooze.option", { option: t(`mail.time.${p.id}`), time: when(p.at) }),
    icon: "clock",
    onSelect: () => onSnooze(p.at),
  }));
  if (snoozedUntil !== undefined && snoozedUntil > now) out.push({ id: "snooze-wake", label: t("mail.action.unsnooze"), icon: "inbox", onSelect: () => onSnooze(null) });
  return out;
}

export function labelEntries(t: Translate, labels: MailLabel[], current: string[], onSet: (ids: string[]) => void): MenuEntry[] {
  return labels.map((l) => {
    const on = current.includes(l.id);
    return { id: `label-${l.id}`, label: t("mail.action.labelAs", { label: l.name }), icon: "tag", selected: on, onSelect: () => onSet(on ? current.filter((x) => x !== l.id) : [...current, l.id]) };
  });
}
